import { Controller } from "stimulus"

# Calculates and displays the maximum registration spend for an event
# based on the number of seats and the per-registrant fee.
#
# Expected markup:
#
#   %div{ data: { controller: 'event--registration-cost-calculator', event__registration_cost_calculator_fee: fee } }
#     = f.text_field :seats, data: { action: 'input->event--registration-cost-calculator#calculate', event__registration_cost_calculator_target: 'seatsInput' }
#     .hidden{ data: { event__registration_cost_calculator_target: 'costDisplay' } }
#       %span{ data: { event__registration_cost_calculator_target: 'costAmount' } }
#
export default class extends Controller
  @targets: ["seatsInput", "costDisplay", "costAmount"]

  connect: ->
    @fee = parseFloat(@data.get("fee")) || 0
    @calculate()

  calculate: ->
    seats = parseInt(@seatsInputTarget.value) || 0
    total = seats * @fee

    if seats > 0 and @fee > 0
      @costAmountTarget.textContent = "$#{ total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }"
      @costDisplayTarget.classList.remove('hidden')
    else
      @costDisplayTarget.classList.add('hidden')
